import keyMirror from 'keymirror';
export default keyMirror({
  SERVER_INFO_SUCCESS: null
});